<script setup>
    import Store from './store';
    import Router from './router'
    import { onBeforeMount } from "vue";
    import { useLayout } from '@/layout/composables/layout';
    import api from './lib/serverApi';
    import utils from './lib/utils';

    const { changeThemeSettings, layoutConfig } = useLayout();

    const changeTheme = (theme, mode) => {
        const elementId = 'theme-css';
        const linkElement = document.getElementById(elementId);
        const cloneLinkElement = linkElement.cloneNode(true);
        const newThemeUrl = linkElement.getAttribute('href').replace(layoutConfig.theme.value, theme);
        cloneLinkElement.setAttribute('id', elementId + '-clone');
        cloneLinkElement.setAttribute('href', newThemeUrl);
        cloneLinkElement.addEventListener('load', () => {
            linkElement.remove();
            cloneLinkElement.setAttribute('id', elementId);
            changeThemeSettings(theme, mode === 'dark');
        });
        linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
    };

    onBeforeMount(async () => {
        try {
            const { theme, mode } = Store.getters.interfaceTheme;
            if (theme) changeTheme(theme, mode);

            api.setSessionData(Store.getters.sessionData);
            const initRes = await api.connect();
            if (!initRes.result) {
                Store.commit('SET_ERROR', 'Не совпадает версия API - обратитесь к администратору!');
                Router.push('/ERROR');
            }

            if (!(await api.checkSession(Store.getters.sessionData))) {
                Store.commit('CLEAR_USER');
                Router.push('/Login');
            } else {
                if (window.location.pathname === '/') {
                    await utils.sleep(2000);
                    Router.push('/App');
                }
            }
        } catch (error) {
            Store.commit('SET_ERROR', error.message);
            Router.push('/ERROR');
        }
    });
</script>


<template>
    <div>
        <router-view />

        <DialogsWrapper />
    </div>
</template>

<style>
.hideElement {
    opacity: 0;
}
.p-confirm-dialog{
    min-width: 300px;
}
</style>